import { View } from "extensions/marionette";
import $ from "jquery";
import { _ } from "extensions/underscore";
import isPlainObject from "lodash-es/isPlainObject";

import { getWalkableModelValue } from "common/utils";
import _template from "./row.jst";
import * as cells from "./cells/_all";

const Presenters = Object.entries(cells).reduce((memo, [name, type]) => ({
    ...memo,
    [name]: new type.Presenter()
}), {});

export const RowView = View.extend({
    template: _template,
    attributes() {
        return {
            "data-modelid": this.model.id
        };
    },
    tagName: "tr",
    triggers: {
        click: "click:row"
    },
    events: {
        "click td": "clickCell"
    },
    modelEvents: {
        change: "reRender"
    },
    
    initialize(options) {
        this.columns = options.columns;
    },
    
    reRender() {
        this.removeAllTooltips();
        this.render();
    },
    
    removeAllTooltips() {
        const allElementsWithPossibleTooltips = this.$el.find("[data-toggle='tooltip']");
        
        allElementsWithPossibleTooltips.each((index, elt) => {
            // Remove tooltip if it exist in object's DOM "data"
            const tooltip = $.data(elt, "bs.tooltip");
            if (tooltip) {
                tooltip.destroy();
                $.data(elt, "bs.tooltip", null);
            }
        });
    },
    
    clickCell(event) {
        const $cell = this._getCell(event);
        this.trigger("click:cell", this, $cell.attr("data-attribute"), this.model, $cell, event);
        this.trigger(`click:cell:${$cell.attr("data-attribute")}`, this, this.model, $cell, event);
    },
    
    // Andrei:
    // not a big fan of relying on DOM for holding the data, but in this case row is the itemView that doesn't
    // differentiate between different TDs it holds. In v2 refactor, make the row as a composite view that holds a
    // collection of cells. Don't see need to make this complex structure now.
    _getCell(event) {
        const $target = $(event.target);
        let cell;
        
        if ($target.attr("data-attribute")) {
            cell = $target;
        } else {
            cell = $target.closest("td");
        }
        return cell;
    },
    
    serializeData(...args) {
        const modelData = View.prototype.serializeData.call(this, ...args);
    
        const getValueFromColumn = (attr) => {
            try {
                if (isPlainObject(attr)) {
                    // Use Object.fromEntries and map when it is accepted
                    return Object.entries(attr).reduce((memo, [key, val]) => {
                        memo[key] = getValueFromColumn(val);
                        return memo;
                    }, {});
                }
                
                if (typeof attr === "function") {
                    return getWalkableModelValue(this.model, attr.bind(this));
                }
    
                return getWalkableModelValue(this.model, attr);
            } catch {
                return "-";
            }
        };
        
        return {
            cells: this.columns.map((column) => {
                const cellType = _.resultPartial(column, "cell", void 0, column);
                try {
                    return Presenters[cellType].present(column, getValueFromColumn(column.attribute), modelData, this.model);
                } catch {
                    // If there is a problem getting value from the attribute then show '-' using generic presenter
                    return Presenters.generic.present(column, "-", modelData, this.model);
                }
            })
        };
    }
});
